import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";
import { VcsIntegration } from "types/generated";

const VCSIntegrationsTableSpaceCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<VcsIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {integration.isDefault ? (
        <TableCellEmpty />
      ) : (
        <SpacePath spaceId={integration.space.id} fallbackName={integration.space.name} />
      )}
    </TableSimpleCell>
  );
};

export default VCSIntegrationsTableSpaceCell;
